import { render, staticRenderFns } from "./definitedetail.vue?vue&type=template&id=4cd70953&scoped=true"
import script from "./definitedetail.vue?vue&type=script&lang=js"
export * from "./definitedetail.vue?vue&type=script&lang=js"
import style0 from "./definitedetail.vue?vue&type=style&index=0&id=4cd70953&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd70953",
  null
  
)

export default component.exports